import { useContext, createContext, useState } from "react";
import {nanoid} from '@reduxjs/toolkit'

import { generatePhoneDetail } from "./phoneUtil";

const DataListContext = createContext();


const DataListProvider = ({children, ...rest}) =>
{
    const [listData, setListData] = useState([]);

    const initDataList=(l)=>
    {
        let list = [];
        if (l && l.length>0)
        {
            l.forEach(
                (x)=>
                    {
                        generatePhoneDetail(x)
                        list.push({...x, nid:nanoid()})
                    }
                  
            )
            
        }
        setListData(list)
    }

    const clearDataList=()=>
    {
        setListData([])
    }
    const addDataList=(data)=>
    {
        if (data)
        {
            let nlist = listData ? [...listData]  :[]; 
            

            nlist.push({...data, nid:nanoid()});
            //alert(nlist.length)
         
            setListData(nlist)
        }
    }
    const editDataList=(data)=>
    {
        if (data && data.nid)
        {
            let index = listData.findIndex( x=> x.nid===data.nid)
            if (index>=0)
            {
                let nlist = [...listData];
                nlist[index]=data;
                setListData(nlist)
            }
        }
    }
    const deleteDataList=(data)=>
    {
        
        if (data && data.nid && listData)
        {
            //alert(JSON.stringify(data))
            let index = listData.findIndex( x=> x.nid===data.nid)
            //alert("Index="+index)
            if (index>=0)
            {
                let nlist = [...listData];
                nlist.splice(index,1)
                //alert(JSON.stringify(nlist))
                setListData(nlist)
            }
        }
    }
    
    

    const value = { 
        listData, 
        initDataList,
        clearDataList,
        addDataList,
        editDataList,
        deleteDataList,
    };

    return(    
        <DataListContext.Provider  value={value}>
            {children}
        </DataListContext.Provider>)  
}

export default DataListProvider

export const useDataListContext=()=> {
    return useContext(DataListContext);
}

